import React, {useState} from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import styled from 'styled-components';
import {GLOBAL_STYLE_CONFIG} from "../../../../../app/styles/GlobalStyles";

interface IProps {
}

const StyledRangeSliderWrapper = styled.div`
    .rc-slider-track, .rc-slider-tracks{
        background-color:var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
    }
 
    .rc-slider-dot-active {
        border-color:  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
    }
    .rc-slider-handle{
        border-color:  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
    }
    .rc-slider-handle:focus-visible {
        border-color:  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
        box-shadow: 0 0 0 3px  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
    }
    .rc-slider-handle-click-focused:focus {
        border-color:  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
        box-shadow: unset;
    }
    .rc-slider-handle:hover {
        border-color:  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
    }
    .rc-slider-handle:active {
        border-color:  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
        box-shadow: 0 0 5px  var(${GLOBAL_STYLE_CONFIG.variable('range', 'bg-color')}, ${({theme}) => theme.colors.primary});
        cursor: -webkit-grabbing;
        cursor: grabbing;
    }
`;

const StyledRangeS = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 8px;

    span {
        font-size: 14px;
    }
`;

interface IProps {
    values: number[];
    onChange: (value: number[]) => void;
    min: number;
    max: number;
}

const RangeSlider = ({values, onChange, min, max}: IProps) => {
    const [range, setrange] = useState<number[]>(values);

    const handleChange = (values: any) => {
        setrange(values); // Обновляем состояние при изменении значений
    };
    const handleAfterChange = (value: any) => {
        onChange(range);
    }

    return (
        <StyledRangeSliderWrapper>
            <Slider
                range // Указываем, что это диапазон с двумя ползунками
                min={min}
                max={max}
                defaultValue={range} // Устанавливаем значение для обоих ползунков
                onChange={handleChange} // Обработчик изменений
                onChangeComplete={handleAfterChange} // Обработчик, когда перестают двигать
            />
            <StyledRangeS>
                <span> {range[0]}</span>
                <span> {range[1]}</span>
            </StyledRangeS>
        </StyledRangeSliderWrapper>
    );
};

export default RangeSlider;
